import axios from './index';

class ClientConfigApi {
  static Get = (data) => {
    return axios.get(`${base}`);
  };

  static Update = (data) => {
    let request = {};
    request.two_factor = data.two_factor ? true : false;
    request.gold_locker = data.gold_locker ? true : false;
    request.saving_plan = data.saving_plan ? true : false;
    if (data.logo_url) request.logo_url = data.logo_url;
    if (data.token_session_time)
      request.token_session_time = Number(data.token_session_time);
    if (data.backend_url) request.backend_url = data.backend_url;
    if (data.frontend_url) request.frontend_url = data.frontend_url;
    if (data.gold_buy_sell_price_gap)
      request.gold_buy_sell_price_gap = Number(data.gold_buy_sell_price_gap);
    if (data.gold_buy_gst) request.gold_buy_gst = Number(data.gold_buy_gst);
    if (data.gold_sell_gst) request.gold_sell_gst = Number(data.gold_sell_gst);
    if (data.advance_book) request.advance_book = Number(data.advance_book);
    request.user_bank_required = data.user_bank_required ? true : false;
    if (data.gold_locker_start_time) request.gold_locker_start_time = data.gold_locker_start_time;
    if (data.gold_locker_end_time) request.gold_locker_end_time = data.gold_locker_end_time;
    if (data.min_app_version_android) request.min_app_version_android = Number(data.min_app_version_android);
    if (data.min_app_version_ios) request.min_app_version_ios = Number(data.min_app_version_ios);

    return axios.put(`${base}`, request);
  };

  static UpdateBullionGap = (data) => {
    let request = {};
    if (data.gold_buy_sell_price_gap) {
      request.gold_buy_sell_price_gap = Number(data.gold_buy_sell_price_gap);
    }
    return axios.put(`dashboard/bullion-price-gap`, request);
  };
}

let base = 'dashboard/client-config';

export default ClientConfigApi;
